export function formatStatementRecipients (recipientGroup, showConsultingCompanyName = false, forceShowConsultingCompanyName = false, divider = ', ') {
    return recipientGroup?.consultants.map(consultant => consultant.getContactName({ consultingCompanyName: showConsultingCompanyName && !consultant.worksForUserConsultingCompany || forceShowConsultingCompanyName })).join(divider) || ''
}
